import {method} from "@/api/api";

export const actions = {
    getList({commit}, params) {
        method('help.article-categories.published', params).then(res => {
            commit('SET_FAQ_CATEGORIES', res.data)
        })
    },
}